import React from 'react';

import { Page } from 'src/components';

const RGPD = () => (
  <Page>
    <Page.Main className="pt-16 mx-auto max-w-screen-2xl">
      <iframe
        title="Protection des données"
        src="./equilibre-rgpd.pdf"
        className="w-full"
        style={{ minHeight: 'calc(100vh - 4rem)' }}
      />
    </Page.Main>
  </Page>
);

export default RGPD;
